// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","successMessage":"messages_successMessage__xUM72"};